var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.01V15.01H16L12 10.01L8 15.01H11V19.01H13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.01H9V17.01H7C5.346 17.01 4 15.664 4 14.01C4 12.606 5.199 11.254 6.673 10.995L7.254 10.893L7.446 10.335C8.149 8.28401 9.895 7.01001 12 7.01001C14.757 7.01001 17 9.25301 17 12.01V13.01H18C19.103 13.01 20 13.907 20 15.01C20 16.113 19.103 17.01 18 17.01H15V19.01H18C20.206 19.01 22 17.216 22 15.01C21.9985 14.1136 21.6966 13.2436 21.1427 12.5388C20.5888 11.8341 19.8147 11.3353 18.944 11.122C18.507 7.68001 15.56 5.01001 12 5.01001C9.244 5.01001 6.85 6.62101 5.757 9.16001C3.609 9.80201 2 11.83 2 14.01C2 16.767 4.243 19.01 7 19.01Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a5a915279f9e8b3bf1f0b15dd521819f.svg";
export { ForwardRef as ReactComponent };